import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from "../components/Logo.js"

function NoPage() {
	return (
		<div className="NoPage vh-100 h-100 d-flex justify-content-center align-items-bottom">
			<Container fluid>
				<Row className="justify-content-center align-items-center vh-100 h-100">
					<Col xs={12} md={12} lg={6} className="bg-light p-4 text-center vh-100 h-100 ">
						<Logo />
						
						<br />
					
						<h2>P&aacute;gina no encontrada</h2>
						
						<br />
						
						<a href="/" className="nav-link text-primary" >INICIAR SESI&Oacute;N</a>
						
					</Col>
				</Row>
			</Container>		
		</div>
	);
}

export default NoPage;
